import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./service-delivery-duration.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./service-delivery-duration.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";


@Injectable()
export class ServiceDeliveryDurationEffects {

  createDeliveryDuration$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServiceDeliveryDuration),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_DELIVERY_PROCEDURE_STEP,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceDeliveryDuration({ serviceDeliveryDuration: result?.data[0] }));
              this.notificationService.successMessage('Created Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateDeliveryDuration$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editServiceDeliveryDuration),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_DELIVERY_PROCEDURE_STEP,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceDeliveryDuration({ serviceDeliveryDuration: result?.data }));
              this.notificationService.successMessage('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteDeliveryDuration$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeServiceDeliveryDuration),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_DELIVERY_PROCEDURE_STEP,
        variables: {
          stepUniqueId: action?.stepUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteServiceDeliveryDuration({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getServiceDeliveryDurations$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceDeliveryDuration),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_DELIVERY_PROCEDURE_STEP,
        fetchPolicy: 'network-only',
        variables: {
          serviceUniqueId: action.serviceUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service delivery duration'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            console.log(result, 'Data')
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceDeliveryDurations({ serviceDeliveryDurations: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
